<template>
  <v-data-table
    :items="getFilteredOrderTemplates"
    :headers="getHeaders"
    :loading="loading"
    :search="search"
    sort-by="name"
    :mobile-breakpoint="0"
    hide-default-footer
    :hide-default-header="$vuetify.breakpoint.xsOnly"
    :items-per-page="$vuetify.breakpoint.xsOnly ? 8 : 10"
    @page-count="pageCount = $event"
    :page.sync="page"
  >
    <template v-slot:item.mobile="{ item }">
      <div class="my-1">
        <v-row align="center" justify="start" no-gutters>
          <span class="caption"
            >Dernière m-à-j: {{ item.updated | shortLocalFormat }}</span
          >
        </v-row>
        <v-row align="center" justify="start" no-gutters class="mt-1">
          <span class="font-weight-bold">{{ item.name }}</span>
        </v-row>
      </div>
    </template>
    <template v-slot:item.updated="{ item }">
      {{ formatDate(item.updated) }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <v-btn
          icon
          :small="!$vuetify.breakpoint.xsOnly"
          @click="editTemplate(item)"
        >
          <v-icon :small="!$vuetify.breakpoint.xsOnly">fa-edit</v-icon>
        </v-btn>
      </v-row>
    </template>
    <template v-slot:top>
      <v-row align="center" justify="end" dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="search"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer>
      <v-pagination
        color="accent"
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "OrderTemplateGrid",
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      showDeleted: false,
      search: "",
      page: 1,
      pageCount: 0
    };
  },
  computed: {
    ...mapGetters(["getOrderTemplates", "getIsAdmin"]),
    getFilteredOrderTemplates() {
      let qs = this.getOrderTemplates;
      if (!this.showDeleted) {
        qs = qs.filter(x => x.is_deleted === false);
      }
      return qs;
    },
    getHeaders() {
      const h = [];
      if (this.$vuetify.breakpoint.xsOnly) {
        h.push({ value: "mobile", text: "" });
      } else {
        h.push({ value: "name", text: "Nom" });
        h.push({ value: "updated", text: "Dernière mise à jour" });
      }
      if (this.getIsAdmin) {
        h.push({ value: "actions", text: "" });
      }
      return h;
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("LLL");
    },
    editTemplate(item) {
      this.$router.push({
        name: "OrderTemplateEditor",
        params: { id: item.id }
      });
    }
  }
};
</script>

<style></style>
